import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminPanel.css";

const AdminPanel = () => {
  const [submissions, setSubmissions] = useState([]);
  const [fields, setFields] = useState([]);
  const [currentBanner, setCurrentBanner] = useState("");
  const [newField, setNewField] = useState({
    label: "",
    name: "",
    fieldType: "text",
    options: [],
    validations: {
      required: false,
      minDate: "",
      maxDate: "",
      minLength: 0,
      maxLength: 0,
      pattern: "",
    },
    helpText: "",
    fieldCategory: "other",
    subFields: [],
  });
  const [optionInput, setOptionInput] = useState("");
  const [bannerFile, setBannerFile] = useState(null);
  const [loading, setLoading] = useState({ pdf: {}, xls: false, banner: false });

  useEffect(() => {
    fetchSubmissions();
    fetchFields();
    fetchBanner();
  }, []);

  const fetchSubmissions = async () => {
    try {
      const res = await axios.get("/api/admin/submissions");
      const sortedSubs = Array.isArray(res.data)
        ? [...res.data].sort(
            (a, b) => new Date(b.submissionDate) - new Date(a.submissionDate)
          )
        : [];
      setSubmissions(sortedSubs);
    } catch (err) {
      console.error("Could not fetch submissions", err);
      alert("Failed to load submissions. Check console.");
    }
  };

  const fetchFields = async () => {
    try {
      const res = await axios.get("/api/form-fields");
      const sortedFields = Array.isArray(res.data)
        ? [...res.data].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        : [];
      setFields(sortedFields);
    } catch (err) {
      console.error("Could not fetch form fields", err);
    }
  };

  const fetchBanner = async () => {
    try {
      const res = await axios.get("/api/banner");
      if (res.data.path) setCurrentBanner(res.data.path);
    } catch (err) {
      console.error("Failed to fetch banner", err);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.startsWith("validations.")) {
      const valKey = name.split(".")[1];
      setNewField((prev) => ({
        ...prev,
        validations: {
          ...prev.validations,
          [valKey]: type === "checkbox" ? checked : value,
        },
      }));
    } else if (name === "helpText" || name === "fieldCategory" || name === "fieldType") {
      setNewField((prev) => {
        const updated = { ...prev, [name]: value };
        if (value === "landline") {
          updated.subFields = [
            { label: "Area Code", name: "landlineArea", maxLength: 5 },
            { label: "Phone Number", name: "landlineNumber", maxLength: 8 },
          ];
        } else if (value === "address") {
          updated.subFields = [
            { label: "Street Address", name: "street1", maxLength: 100 },
            { label: "Street Address Line 2", name: "street2", maxLength: 100 },
            { label: "City", name: "city", maxLength: 50 },
            { label: "State / Province", name: "state", maxLength: 50 },
            { label: "Postal / Zip Code", name: "zip", maxLength: 10 },
          ];
        } else if (!["landline", "address"].includes(value)) {
          updated.subFields = [];
        }
        return updated;
      });
    } else if (name.startsWith("subField_")) {
      const [_, index, prop] = name.split("_");
      const idx = parseInt(index);
      setNewField((prev) => {
        const updated = { ...prev };
        updated.subFields[idx] = {
          ...updated.subFields[idx],
          [prop]: prop === "maxLength" ? parseInt(value) || 0 : value,
        };
        return updated;
      });
    } else {
      setNewField((prev) => ({ ...prev, [name]: value }));
    }
  };

  const addOption = () => {
    if (optionInput && !newField.options.includes(optionInput)) {
      setNewField((prev) => ({
        ...prev,
        options: [...prev.options, optionInput],
      }));
      setOptionInput("");
    }
  };

  const addSubField = () => {
    setNewField((prev) => ({
      ...prev,
      subFields: [
        ...prev.subFields,
        { label: "", name: "", maxLength: 100 }
      ],
    }));
  };

  const removeSubField = (index) => {
    setNewField((prev) => ({
      ...prev,
      subFields: prev.subFields.filter((_, i) => i !== index),
    }));
  };

//   const handleFieldSubmit = async (e) => {
//     e.preventDefault();

//     let fieldName = newField.name.trim();
//     if (!fieldName) {
//       const prefix = newField.fieldCategory === "fatheroccupation" ? "father" :
//                     newField.fieldCategory === "motheroccupation" ? "mother" :
//                     newField.fieldCategory === "application" ? "app" :
//                     newField.fieldCategory === "communication" ? "comm" : "";
//       fieldName = `${prefix}${newField.label.toLowerCase().replace(/\s+/g, '')}`;
//     }

//     let payload = { ...newField, name: fieldName };

//     if (newField.fieldType === "landline") {
//       payload.subFields = [
//         { label: "Area Code", name: `${fieldName}Area`, maxLength: 5 },
//         { label: "Phone Number", name: `${fieldName}Number`, maxLength: 8 }
//       ];
//     } else if (newField.fieldType === "address") {
//       payload.subFields = [
//         { label: "Street Address", name: `${fieldName}Street1`, maxLength: 100 },
//         { label: "Street Address Line 2", name: `${fieldName}Street2`, maxLength: 100 },
//         { label: "City", name: `${fieldName}City`, maxLength: 50 },
//         { label: "State / Province", name: `${fieldName}State`, maxLength: 50 },
//         { label: "Postal / Zip Code", name: `${fieldName}Zip`, maxLength: 10 }
//       ];
//     } else if (newField.subFields.length > 0) {
//       payload.subFields = newField.subFields.map(sf => ({
//         ...sf,
//         name: sf.name || `${fieldName}${sf.label.replace(/\s+/g, '')}`
//       }));
//     } else {
//       payload.subFields = undefined;
//     }

//     try {
//       await axios.post("/api/admin/form-fields", payload);
//       alert("Field created successfully!");
//       fetchFields();
//       setNewField({
//         label: "",
//         name: "",
//         fieldType: "text",
//         options: [],
//         validations: {
//           required: false,
//           minDate: "",
//           maxDate: "",
//           minLength: 0,
//           maxLength: 0,
//           pattern: "",
//         },
//         helpText: "",
//         fieldCategory: "other",
//         subFields: [],
//       });
//       setOptionInput("");
//     } catch (err) {
//       const msg = err.response?.data?.message || "Failed to create field";
//       alert("Error: " + msg);
//     }
//   };

const handleFieldSubmit = async (e) => {
  e.preventDefault();
  
  let fieldName = newField.name.trim();
  if (!fieldName) {
    const prefix = newField.fieldCategory === "fatheroccupation" ? "father" :
                  newField.fieldCategory === "motheroccupation" ? "mother" :
                  newField.fieldCategory === "application" ? "app" :
                  newField.fieldCategory === "communication" ? "comm" : "";
    fieldName = `${prefix}${newField.label.toLowerCase().replace(/\s+/g, '')}`;
  }

  // AUTO CALCULATE ORDER
  let newOrder = 0;
  if (fields.length > 0) {
    const maxOrder = Math.max(...fields.map(f => f.order || 0));
    newOrder = maxOrder + 1;
  }

  let payload = { 
    ...newField, 
    name: fieldName,
    order: newOrder  // THIS IS THE KEY FIX
  };

  if (newField.fieldType === "landline") {
    payload.subFields = [
      { label: "Area Code", name: `${fieldName}Area`, maxLength: 5 },
      { label: "Phone Number", name: `${fieldName}Number`, maxLength: 8 }
    ];
  } else if (newField.fieldType === "address") {
    payload.subFields = [
      { label: "Street Address", name: `${fieldName}Street1`, maxLength: 100 },
      { label: "Street Address Line 2", name: `${fieldName}Street2`, maxLength: 100 },
      { label: "City", name: `${fieldName}City`, maxLength: 50 },
      { label: "State / Province", name: `${fieldName}State`, maxLength: 50 },
      { label: "Postal / Zip Code", name: `${fieldName}Zip`, maxLength: 10 }
    ];
  } else if (newField.subFields.length > 0) {
    payload.subFields = newField.subFields.map(sf => ({
      ...sf,
      name: sf.name || `${fieldName}${sf.label.replace(/\s+/g, '')}`
    }));
  } else {
    payload.subFields = undefined;
  }

  try {
    await axios.post("/api/admin/form-fields", payload);
    alert("Field created successfully with order: " + newOrder);
    fetchFields();
    setNewField({
      label: "",
      name: "",
      fieldType: "text",
      options: [],
      validations: {
        required: false,
        minDate: "",
        maxDate: "",
        minLength: 0,
        maxLength: 0,
        pattern: "",
      },
      helpText: "",
      fieldCategory: "other",
      subFields: [],
    });
    setOptionInput("");
  } catch (err) {
    const msg = err.response?.data?.message || "Failed to create field";
    alert("Error: " + msg);
  }
};

  const handleBannerUpload = async (e) => {
    e.preventDefault();
    if (!bannerFile) {
      alert("Please select a file to upload.");
      return;
    }
    setLoading(prev => ({ ...prev, banner: true }));
    const formData = new FormData();
    formData.append("bannerImage", bannerFile);
    try {
      const res = await axios.post("/api/admin/banner-upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert(res.data.message);
      fetchBanner();
    } catch (err) {
      alert("Banner upload failed: " + (err.response?.data?.message || "Server error"));
    } finally {
      setLoading(prev => ({ ...prev, banner: false }));
    }
  };

  const handleDownload = async (url, filename, isPdf = false, submissionId = null) => {
    const key = isPdf ? submissionId : 'xls';
    setLoading(prev => ({ ...prev, pdf: { ...prev.pdf, [key]: true } }));

    try {
      const response = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
      alert(`Download failed: ${error.response?.data?.message || "Server error"}`);
    } finally {
      setLoading(prev => ({
        ...prev,
        pdf: { ...prev.pdf, [key]: false },
        xls: isPdf ? prev.xls : false
      }));
    }
  };

  const handleDeleteField = async (fieldId, fieldLabel) => {
    if (window.confirm(`Are you sure you want to delete the field "${fieldLabel}"?`)) {
      try {
        await axios.delete(`/api/admin/form-fields/${fieldId}`);
        alert(`Field "${fieldLabel}" deleted successfully!`);
        fetchFields();
      } catch (err) {
        alert("Error deleting field: " + (err.response?.data?.message || "Server error"));
      }
    }
  };

  const handleDeleteSubmission = async (submissionId) => {
    if (window.confirm(`Are you sure you want to delete this submission?`)) {
      try {
        await axios.delete(`/api/admin/submissions/${submissionId}`);
        alert("Submission deleted successfully!");
        fetchSubmissions();
      } catch (err) {
        alert("Error deleting submission: " + (err.response?.data?.message || "Server error"));
      }
    }
  };

  const getFormDataPreview = (formData) => {
    if (!formData) return {};
    if (typeof formData.entries === "function") {
      return Object.fromEntries(Array.from(formData.entries()));
    }
    return formData;
  };

  return (
    <div className="admin-panel container">
      <h2>Admin Panel</h2>

      {/* BANNER UPLOADER */}
      <div className="banner-uploader">
        <h3>Header Banner</h3>
        {currentBanner && (
          <img
            src={currentBanner}
            alt="Current Banner"
            className="form-banner"
            style={{ maxHeight: "120px", objectFit: "contain", marginBottom: "10px" }}
          />
        )}
        <form onSubmit={handleBannerUpload}>
          <div className="form-group">
            <label>Upload New Banner Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setBannerFile(e.target.files[0])}
              className="form-control"
              disabled={loading.banner}
            />
          </div>
          <button type="submit" className="submit-btn" disabled={loading.banner}>
            {loading.banner ? "Uploading..." : "Upload Banner"}
          </button>
        </form>
      </div>
      <hr />

      {/* CREATE NEW FIELD */}
      <div className="form-creator">
        <h3>Create New Form Field</h3>
        <form onSubmit={handleFieldSubmit} className="registration-form">

          <div className="form-group">
            <label>Field Label *</label>
            <input
              type="text"
              name="label"
              value={newField.label}
              onChange={handleFieldChange}
              required
              className="form-control"
              placeholder="e.g. Father's Occupation"
            />
          </div>

          <div className="form-group">
            <label>Field Name (auto-generated if empty)</label>
            <input
              type="text"
              name="name"
              value={newField.name}
              onChange={handleFieldChange}
              className="form-control"
              placeholder="e.g. fatherOccupation"
            />
          </div>

          <div className="form-group">
            <label>Field Category (for PDF Layout) *</label>
            <select
              name="fieldCategory"
              value={newField.fieldCategory}
              onChange={handleFieldChange}
              className="form-control"
              required
            >
              <option value="application">Application Details</option>
              <option value="communication">Communication Details</option>
              <option value="fatheroccupation">Father's Occupation Details</option>
              <option value="motheroccupation">Mother's Occupation Details</option>
              <option value="other">Other Details</option>
            </select>
            <small className="help-text">
              Choose where this field should appear in the PDF.
            </small>
          </div>

          <div className="form-group">
            <label>Field Type *</label>
            <select
              name="fieldType"
              value={newField.fieldType}
              onChange={handleFieldChange}
              className="form-control"
              required
            >
              <option value="text">Text (single line)</option>
              <option value="textarea">Text Area (multi line)</option>
              <option value="date">Date (D.O.B)</option>
              <option value="tel">Phone Number</option>
              <option value="email">Email</option>
              <option value="radio">Radio Button</option>
              <option value="checkbox">Checkbox</option>
              <option value="select">Dropdown (Select)</option>
              <option value="landline">Landline (Area + Phone)</option>
              <option value="address">Address (5 subfields)</option>
            </select>
          </div>

          {/* DYNAMIC SUBFIELDS */}
          {(newField.fieldType === "landline" || newField.fieldType === "address" || newField.subFields.length > 0) && (
            <div className="form-group">
              <label>
                {newField.fieldType === "landline" ? "Landline Subfields" :
                 newField.fieldType === "address" ? "Address Subfields" :
                 "Custom Subfields"}
              </label>
              {newField.subFields.map((sub, idx) => (
                <div key={idx} style={{ marginBottom: "10px", display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                  <input
                    type="text"
                    name={`subField_${idx}_label`}
                    value={sub.label}
                    onChange={handleFieldChange}
                    placeholder="Label"
                    className="form-control"
                    style={{ width: "120px" }}
                    required
                  />
                  <input
                    type="text"
                    name={`subField_${idx}_name`}
                    value={sub.name}
                    onChange={handleFieldChange}
                    placeholder="Field Name"
                    className="form-control"
                    style={{ width: "140px" }}
                  />
                  <input
                    type="number"
                    name={`subField_${idx}_maxLength`}
                    value={sub.maxLength}
                    onChange={handleFieldChange}
                    placeholder="Max"
                    className="form-control"
                    style={{ width: "60px" }}
                  />
                  <button
                    type="button"
                    onClick={() => removeSubField(idx)}
                    style={{
                      background: "#dc3545",
                      color: "white",
                      border: "none",
                      padding: "5px 8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    X
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={addSubField}
                className="submit-btn"
                style={{ marginTop: "8px", fontSize: "0.9em" }}
              >
                + Add Subfield
              </button>
              <small className="help-text">
                {newField.fieldType === "landline" && "Area Code: max 5 digits | Phone Number: max 8 digits"}
                {newField.fieldType === "address" && "Street, City, State, ZIP"}
              </small>
            </div>
          )}

          {/* OPTIONS FOR RADIO/SELECT */}
          {(newField.fieldType === "radio" || newField.fieldType === "select") && (
            <div className="form-group">
              <label>Options</label>
              <div style={{ marginBottom: "8px" }}>
                {newField.options.map((opt, i) => (
                  <span key={i} className="tag" style={{ margin: "2px" }}>
                    {opt}
                    <button
                      type="button"
                      onClick={() => setNewField(prev => ({
                        ...prev,
                        options: prev.options.filter((_, idx) => idx !== i)
                      }))}
                      style={{ marginLeft: "5px", background: "none", border: "none", color: "red", cursor: "pointer" }}
                    >
                      X
                    </button>
                  </span>
                ))}
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <input
                  type="text"
                  value={optionInput}
                  onChange={(e) => setOptionInput(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && (e.preventDefault(), addOption())}
                  placeholder="Type option and press Enter or click Add"
                  className="form-control"
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  onClick={addOption}
                  className="submit-btn"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Add Option
                </button>
              </div>
            </div>
          )}

          {/* DATE VALIDATIONS */}
          {newField.fieldType === "date" && (
            <>
              <div className="form-group">
                <label>Min Date</label>
                <input
                  type="date"
                  name="validations.minDate"
                  value={newField.validations.minDate}
                  onChange={handleFieldChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Max Date</label>
                <input
                  type="date"
                  name="validations.maxDate"
                  value={newField.validations.maxDate}
                  onChange={handleFieldChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Help Text</label>
                <input
                  type="text"
                  name="helpText"
                  value={newField.helpText}
                  onChange={handleFieldChange}
                  className="form-control"
                  placeholder="e.g. Select your date of birth"
                />
              </div>
            </>
          )}

          {/* TEL VALIDATIONS */}
          {newField.fieldType === "tel" && (
            <>
              <div className="form-group">
                <label>Min Length</label>
                <input
                  type="number"
                  name="validations.minLength"
                  value={newField.validations.minLength}
                  onChange={handleFieldChange}
                  className="form-control"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Max Length</label>
                <input
                  type="number"
                  name="validations.maxLength"
                  value={newField.validations.maxLength}
                  onChange={handleFieldChange}
                  className="form-control"
                  min="0"
                />
              </div>
            </>
          )}

          {/* EMAIL PATTERN */}
          {newField.fieldType === "email" && (
            <div className="form-group">
              <label>Pattern (email regex)</label>
              <input
                type="text"
                name="validations.pattern"
                value={
                  newField.validations.pattern ||
                  "^[^@]+@[^@]+\\.[^@]+$"
                }
                onChange={handleFieldChange}
                className="form-control"
                placeholder="^[^@]+@[^@]+\\.[^@]+$"
              />
            </div>
          )}

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="validations.required"
                checked={newField.validations.required}
                onChange={handleFieldChange}
              />{" "}
              Required Field
            </label>
          </div>

          <button type="submit" className="submit-btn">
            Create Field
          </button>
        </form>
      </div>
      <hr />

      {/* EXISTING FIELDS */}
      <div className="existing-fields">
        <h3>Existing Form Fields</h3>
        <ul className="field-list" style={{ listStyle: "none", padding: 0 }}>
          {fields.map((f) => {
            const categoryLabel = {
              application: "Application Details",
              communication: "Communication Details",
              fatheroccupation: "Father's Occupation Details",
              motheroccupation: "Mother's Occupation Details",
              other: "Other Details",
            }[f.fieldCategory] || "Other Details";

            return (
              <li
                key={f._id}
                style={{
                  margin: "8px 0",
                  padding: "10px",
                  background: "#f8f9fa",
                  borderRadius: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <strong>{f.label}</strong> ({f.fieldType})
                  {f.subFields && f.subFields.length > 0 && (
                    <span style={{ marginLeft: "8px", fontSize: "0.85em", color: "#555" }}>
                      [{f.subFields.map(sf => sf.label).join(", ")}]
                    </span>
                  )}
                  {" - "}
                  <span
                    className={`category-tag ${f.fieldCategory}`}
                    style={{
                      fontSize: "0.8em",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      background: "#e9ecef",
                      color: "#495057",
                    }}
                  >
                    {categoryLabel}
                  </span>
                </div>
                <button
                  onClick={() => handleDeleteField(f._id, f.label)}
                  style={{
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "0.8em",
                  }}
                >
                  Delete
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <hr />

      {/* SUBMISSIONS */}
      <div className="submissions-section">
        <h3>All Submissions</h3>
        <button
          onClick={() =>
            handleDownload(
              "/api/admin/submissions/download/xls",
              "all-submissions.xlsx",
              false
            )
          }
          className="download-all-btn"
          disabled={loading.xls}
          style={{ opacity: loading.xls ? 0.7 : 1 }}
        >
          {loading.xls ? "Generating..." : "Download All as XLS"}
        </button>
        <table className="submissions-table">
          <thead>
            <tr>
              <th>Submission Date</th>
              <th>Data Preview</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(submissions) && submissions.length > 0 ? (
              submissions.map((sub) => (
                <tr key={sub._id}>
                  <td>{new Date(sub.submissionDate).toLocaleString()}</td>
                  <td style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {JSON.stringify(getFormDataPreview(sub.formData)).slice(0, 100)}...
                  </td>
                  <td>
                    <button
                      onClick={() =>
                        handleDownload(
                          `/api/admin/submissions/${sub._id}/download/pdf`,
                          `MVM-PREKG-${sub._id}.pdf`,
                          true,
                          sub._id
                        )
                      }
                      disabled={loading.pdf[sub._id]}
                      style={{
                        marginRight: "5px",
                        opacity: loading.pdf[sub._id] ? 0.7 : 1,
                        position: "relative"
                      }}
                    >
                      {loading.pdf[sub._id] ? "Generating..." : "Download PDF"}
                    </button>
                    <button
                      onClick={() => handleDeleteSubmission(sub._id)}
                      style={{
                        background: "#dc3545",
                        color: "white",
                        border: "none",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">No submissions yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPanel;